import React from 'react';
type ProductNameProps = {
  className?: string;
  as?: 'p' | 'h2' | 'h3';
};
export function ProductName({
  className = '',
  as = 'p'
}: ProductNameProps) {
  const Tag = as;
  return <Tag className={`font-serif font-semibold text-espresso ${className}`} aria-label="Pastry Instructor Ready" data-id="element-192" data-mp="pm5lufumgama">
      Pastry Instructor{' '}
      <span className="font-script text-[1.35em] font-normal text-raspberry" data-id="element-193" data-mp="kp5f02py73u4">
        Ready
      </span>
    </Tag>;
}